export const aboutData = {
  title: "Who I am",
  description1:
    "Hi, I’m Gaurav! I believe in simplicity and reliability. Whether building digital solutions or solving problems, I focus on making things work efficiently and seamlessly. With expertise in Python, JavaScript, Flask, and Django, I specialize in creating APIs, integrating systems, and improving user experiences.",
  description2:
    "When I’m not coding, I recharge by reading, exploring tech trends, or taking walks to clear my mind. I also enjoy travelling, games, and constantly learning new skills to fuel my creativity. I’m always looking for ways to improve how we interact with the digital world.",
  image: 2,
};
